export function getProviderObject(name, object = null) {
  return {
    name: name,
    isProvider: true,
    type: object !== null ? object.type : null,
  };
}
